module.exports = __webpack_public_path__ + "static/media/CL 10.41c858f6.mp3";